<ng-select
  class="custom"
  [class.invalid-email]="!isCurrentInputValid"
  [placeholder]="placeholder"
  [items]="userList | async"
  [addTag]="validateAndAddTag"
  [typeahead]="typeahead"
  addTagText="Enter new email:"
  (change)="onChange($event)"
  (open)="onOpen()"
  required>
  <ng-template ng-label-tmp let-item="item">
    {{ item.username }}
    @if (item.emailAddress && item.username) {
      <span class="fw-bold">: {{ item.emailAddress }}</span>
    } @else if (!item.username?.length && item.emailAddress) {
      <span class="fw-bold"> {{ item.emailAddress }}</span>
    }
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    {{ item.username }} :<span class="fw-bold"> {{ item.emailAddress }} </span>
  </ng-template>
  @if (!listLoading) {
    <ng-template ng-footer-tmp>
      @if (!isCurrentInputValid) {
        <div class="text-danger">Please enter a valid email address</div>
      } @else {
        Showing {{ loadResultsCount }} of {{ loadResultsTotal }}
      }
    </ng-template>
  }
</ng-select>
